export default __webpack_public_path__ + "static/media/gitlab.154caaf6.png";